import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { FlyControls } from 'three/examples/jsm/controls/FlyControls.js'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'
import * as dat from 'dat.gui'
import { ObjectLoader } from 'three'


// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
scene.background = new THREE.Color(0x121212);

// Objects

const objLoader = new OBJLoader();
objLoader.setPath('./');
objLoader.load('./backpack.obj', (object) => {
	object.scale.set(0.05,0.05,0.05);
    object.position.set(0,-0.75,0);
	scene.add(object);

}, (xhr) => {
	console.log(`carregando objeto = ${(xhr.loaded / xhr.total)*100}`)
}, (err) => {
		console.log(`Erro = ${err}`)
	}
);

// Lights

const pointLight = new THREE.PointLight(0xffffff, 0.1)
pointLight.position.x = 2
pointLight.position.y = 3
pointLight.position.z = 4
scene.add(pointLight)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 0
camera.position.y = 0
camera.position.z = 2
scene.add(camera)

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

const animate = function animate() {
	requestAnimationFrame(animate);
	renderer.render(scene,camera);
	// controls.update();
	
    var lastScrollTop = 0;
	document.querySelector('.main').addEventListener('scroll', e => {
        console.log('scroll')
        var moveCheck = window.pageYOffset || e.target.scrollTop; 
        console.log(moveCheck)
        console.log(lastScrollTop)
        if (moveCheck > lastScrollTop) {
            console.log('down')
            // downscroll code
            if(camera.position.z >= 0.9) {
                camera.position.x = (0) - ((e.target.scrollTop) / 1000);
                camera.position.y = (0) + ((e.target.scrollTop) / 10000);
                camera.position.z = (2 - (e.target.scrollTop / 1000));
                console.log(camera.position.z);
            }
        } else if (moveCheck < lastScrollTop) {
            // upscroll code
            console.log('up')
            camera.position.x = (0) - ((e.target.scrollTop) / 1000);
            camera.position.y = (0) + ((e.target.scrollTop) / 10000);
            camera.position.z = (2 - (e.target.scrollTop / 1000));
            console.log(camera.position.z);
        } 
        lastScrollTop = moveCheck <= 0 ? 0 : moveCheck;
		
	})
}

animate();